import { render, staticRenderFns } from "./ContaReceber.vue?vue&type=template&id=f4c94144&"
import script from "./ContaReceber.vue?vue&type=script&lang=js&"
export * from "./ContaReceber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports